import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../styles/background.css";

export default function Layout({ children }) {
  return (
    <div className="background-container">
      <div className="background-overlay"></div>
      <div className="animated-shapes">
        <div className="shape"></div>
        <div className="shape"></div>
        <div className="shape"></div>
      </div>
      <Header />
      <main className="background-content">
        <div className="app-content">
          {children}
        </div>
      </main>
      <Footer />
    </div>
  );
}
